import React, { Component } from "react";
// import Dropzone from "react-dropzone";
import { UncontrolledTooltip, Badge, Input, Button } from "reactstrap";
import { fetchData } from "../common/networkRequests";
import * as XLSX from 'xlsx';
import { indexOf } from "lodash";



const uuidv4 = require('uuid/v4');


// import request from "request";
// import { Line } from "rc-progress";

const getStartingRow = (data) => {
  let cnt = 1;
  let startsat;
  while (cnt < 10) {
    if (data['A' + cnt] && String(data['A' + cnt]['w']).trim() == '1' && data['A' + (cnt + 1)] && String(data['A' + (cnt + 1)]['w']).trim() == '2') {
      startsat = cnt;
      break;
    }
    cnt += 1;
  }
  return startsat;
}


const getFirstRow = (data, file_amount) => {
  let startsat;
  for (var key in data) {
    if (data[key]['w'] == String(file_amount)) {
      startsat = key.replace(/[a-zA-Z]/g, '');
    }
  }
  return startsat;
}

const generateGridDataFromXls = ({ data, startsAt, endsAt, name_column, amount_column, account_column, ifsc_column, mobileno_column }) => {
  let finalData = [];
  for (var i = startsAt; i <= endsAt; i++) {

    let full_name = data[name_column + i]['w'];
    let account_no = data[account_column + i] ? data[account_column + i]['w'] : "";
    let total_amount = data[amount_column + i]['w'];
    let ifsc = '';
    if (data[ifsc_column + i]) {
      ifsc = data[ifsc_column + i]['w'];
    }

    let mobileno = '';
    if (data[mobileno_column + i]) {
      mobileno = data[mobileno_column + i]['w'];
    }


    let row = { full_name, account_no, total_amount, ifsc, mobile: mobileno };
    finalData.push(row);

  }
  return finalData;
}

const devnagariToEnglishNumbers = (st) => {
  let dev = { "०": 0, "१": 1, "२": 2, "३": 3, "४": 4, "५": 5, "६": 6, "७": 7, "८": 8, "९": 9 };
  return dev[st];
}


const getImportantColumns = (data, startsat, file_amount, name_column = 'B') => {
  let ends_at = startsat;
  let totals = {};
  let amount_column;
  let account_column;
  let ifsc_column;
  let ifsc_cnt = 0;
  let mobileno_column;
  let mobileno_cnt = 0;
  let success;
  let alldata = {};

  for (var key in data) {
    let rowno = parseInt(key.substring(1, 10));
    if (rowno >= startsat) {
      let columnname = key.substring(0, 1);
      if (columnname == name_column && rowno == ends_at + 1 && data['A' + rowno]) {
        ends_at = rowno;
      }
    }
  }
  let ifsc_success = {};
  let mobileno_success = {};


  for (var key in data) {
    let rowno = parseInt(key.substring(1, 10));
    if (rowno >= startsat && rowno <= ends_at) {
      let columnname = key.substring(0, 1);
      let colval = data[key]['w'];

      if (!totals[columnname]) {
        totals[columnname] = 0;
      }
      if (!alldata[columnname]) {
        alldata[columnname] = [];
      }
      totals[columnname] += parseFloat(colval);
      alldata[columnname].push(colval);

      if (colval.length == 11) {
        let patt = new RegExp("^([a-zA-Z]){4}([0-9]){7}");
        let result = patt.test(colval);
        if (result) {
          ifsc_success[columnname] = ifsc_success[columnname] ? ifsc_success[columnname] + 1 : 1;
        }
      }

      if (colval.length == 10) {
        let patt = new RegExp("^([0-9]){10}");
        let result = patt.test(colval);
        if (result) {
          mobileno_success[columnname] = mobileno_success[columnname] ? mobileno_success[columnname] + 1 : 1;
        }
      }
    }
  }

  for (var k in ifsc_success) {
    if (ifsc_success[k] > ifsc_cnt) {
      ifsc_column = k;
      ifsc_cnt = ifsc_success[k];
    }
  }


  console.log({ mobileno_success, data, totals, alldata });

  let difference;
  let actual_sum;
  for (var k in totals) {
    if (totals[k] > file_amount - file_amount * .0005 && totals[k] < file_amount + file_amount * .0005) { // get the totals from 'v' also to be sure.
      amount_column = k;
      difference = file_amount - totals[k];
      actual_sum = totals[k];
    }
    else if (totals[k] > file_amount * 1000) {
      account_column = k;
    }
  }


  for (var k in mobileno_success) {
    if (mobileno_success[k] > mobileno_cnt && account_column != account_column) {
      mobileno_column = k;
      mobileno_cnt = mobileno_success[k];
    }
  }

  return { ends_at, amount_column, account_column, difference, actual_sum, ifsc_column, mobileno_column };
}




function getReadfileToObject(str) {
  var result = [];
  let truncated = 0;
  var keys = str[0].split(",");
  for (var i = 1; i < str.length; i++) {
    var obj = {};
    if (str[i].trim() != '') {
      let row = str[i].replace(/(?!(([^"]*"){2})*[^"]*$),/g, '.').replace(/"/g, '');
      var currentVal = row.split(",");
      for (var j = 0; j < keys.length; j++) {
        if (currentVal[j] != "" && currentVal[j] != undefined) {
          if (keys[j].trim().indexOf('is_') != -1) {
            obj[keys[j].trim()] = (currentVal[j] && currentVal[j] != '') ? true : false;
          } else {
            obj[keys[j].trim()] = currentVal[j];
          }
        }
      }
      result.push(obj);
      // if (i > 10000) {
      //   truncated = i;
      //   break;
      // }
    }
  }
  return [result, truncated]
}

class FileUploadCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.state = {
      preview: null, size: 0,
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)),
      fileuploadMessage: "",
      file: ""
    };
  }
  handleChange(files) {
    // console.log(files);
    // console.log(this.props)
    // this.props.liftState(this.props.component, files);
  }

  componentDidMount() {
    let { fileFolder } = this.props.parentState;
    if (
      this.props.parentState.pageData &&
      !this.props.parentState.pageData[this.props.component.name] &&
      this.props.component.default && !fileFolder.isOpen
    ) {
      this.props.liftState(this.props.component, this.props.component.default);
    }
  }

  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }

  onUploadFile = async (e, fileTypes) => {
    let { readFile } = this.props.component;
    let { remoteip } = this.props.parentState;
    let current = this;

    try {
      let files = e.target.files;
      let filebin = files[0];
      let filesize = filebin.size;
      // alert(filesize)


      if (filesize < 2000000) {
        if (readFile) {
          this.setState({ file: filebin });
          let fileSize = filebin.size < 2048 ? filebin.size + "Bytes" : Math.round(filebin.size / 1024) + "KB";

          let allreturnData;
          if (readFile.type == 'xls' && e.target.files.length > 0 && readFile.purpose == 'calamity_funds') {
            this.props.liftGlobalState({ name: 'directloading' }, true);
            const reader = new FileReader();
            reader.onload = (e) => { // evt = on_file_select event
              const bstr = e.target.result;
              const wb = XLSX.read(bstr, { type: 'binary' });
              const wsname = wb.SheetNames[0];
              const wsdata = wb.Sheets[wsname];
              let name_column = 'B';
              let file_amount = parseInt(this.props.parentState.pageData.file_amount);
              let total_count = parseInt(this.props.parentState.pageData.total_count);
              let startsAt;
              if (total_count == 1) {
                startsAt = getFirstRow(wsdata, file_amount);
              } else {
                startsAt = getStartingRow(wsdata);
              }

              let res = getImportantColumns(wsdata, startsAt, file_amount, name_column);
              let endsAt = res['ends_at'];
              let amount_column = res['amount_column'];
              let account_column = res['account_column'];
              let ifsc_column = res['ifsc_column'];
              let mobileno_column = res['mobileno_column'];



              if (res['difference']) {
                this.props.liftState({ name: 'round_figure_difference' }, res['difference']);
              }

              if (res['actual_sum']) {
                this.props.liftState({ name: 'actual_sum' }, res['actual_sum']);
              }

              // console.log({ total_count, endsAt, startsAt, amount_column })

              if (total_count != endsAt - startsAt + 1) {
                alert("फाइलमधील शेतकरी संख्या हि वरील शेतकरी संख्येला जुळत नाही!");
              } else if (!amount_column) {
                alert("फाइलमधील एकूण रक्कम हि वरील एकूण रक्कमेला जुळत नाही!");
              } else {
                let finalData = generateGridDataFromXls({ data: wsdata, startsAt, endsAt, name_column, amount_column, account_column, ifsc_column, mobileno_column });
                // console.log({ finalData })
                current.props.liftState({ name: readFile.targetTable }, finalData);
              }
              this.props.liftGlobalState({ name: 'directloading' }, false);
            };
            reader.readAsBinaryString(filebin);

          }
          else if (readFile.type == 'csv' && e.target.files.length > 0) {
            var reader = new FileReader();
            let filename = e.target.files[0].name;
            if (readFile.set_file_name) {
              current.props.liftState({ name: readFile.set_file_name }, filename);
            }

            reader.onload = function (e) {
              let file_data = e.target.result;
              let proceed = false;


              let first_row = file_data.split("\n")[0];
              if (first_row.replace('\r', '').toLowerCase() != readFile.columns.join(",").toLowerCase()) {
                if (first_row.replace('\r', '').toLowerCase().indexOf(readFile.columns.join(",").toLowerCase()) != -1) {
                  console.log("1")
                  proceed = true;
                } else {
                  let file_columns = first_row.replace('\r', '').toLowerCase().split(",");
                  let success = 0;
                  let x;
                  let rfc = readFile.columns;
                  rfc.map(col => file_columns.indexOf(col.toLowerCase()) != -1 ? success += 1 : x = 0)
                  if (success == rfc.length) {
                    proceed = true;
                  }
                  if (!proceed && rfc.length == file_columns.length) {
                    file_data = readFile.columns.join(",") + "\n" + file_data;
                    proceed = true;
                  }
                }
              } else {
                proceed = true;
              }

              if (proceed) {
                var rows = file_data.split("\n");
                let retData = getReadfileToObject(rows);
                allreturnData = retData[0];

                current.setState({ truncated: retData[1] })
                current.props.liftState({ name: readFile.targetTable }, allreturnData);
                current.setState({ fileuploadMessage: "" })
                current.setState({ preview: filebin.name, size: fileSize });
              } else {
                // FAILING case - if the sequence & no of columns is incorrect and there are no headers.
                alert("incorrect file format");
              }
            }
            reader.readAsText(filebin);

          } else {
            alert("Incorrect file type provided. This box only accepts " + readFile.type + " file types");
          }
        } else {

          this.setState({ file: filebin });
          let fileSize = filebin.size < 2048 ? filebin.size + "Bytes" : Math.round(filebin.size / 1024) + "KB";


          const formData = new FormData();
          formData.append('file', filebin);

          let CBSurl = `${remoteip}/files3`;
          let method = 'post';
          let { token } = this.props.parentProps.parentState;

          this.setState({ fileuploadMessage: " Uploading..." });

          // show uploading, compressing, virus scanning.

          let response = await fetchData({ url: CBSurl, postData: formData, method, headers: { Authorization: `JWT ${token}` }, dontencrypt: true });
          current.setState({ fileuploadMessage: "" });

          if (response && response.success) {
            let url = response.url;
            this.props.liftState(this.props.component, url);
            this.setState({ preview: filebin.name, size: fileSize });
          }

          // // Check whether single or multiple files.
          // const formData = new FormData();
          // formData.append('my_photo', filebin);

          // let CBSurl = `${remoteip}/file`;
          // let method = 'post';
          // let { token } = this.props.parentProps.parentState;

          // this.setState({ fileuploadMessage: "Loading..." });

          // let response = await fetchData({ url: CBSurl, postData: formData, method, headers: { Authorization: `JWT ${token}` } });
          // current.setState({ fileuploadMessage: "" });

          // if (response) {
          //   let savedfilename = response.savedfilename;
          //   this.props.liftState(this.props.component, savedfilename);

          //   this.setState({ preview: filebin.name, size: fileSize });
          // }
        }
      } else {
        alert("File size can not be more than 1MB")
      }
    }
    catch (err) {
      console.log(err);
    }
    e.preventDefault();

  }

  onDownloadFile = async (filename) => {
    let { remoteip, pageData } = this.props.parentState
    let method = 'get';
    let { token } = this.props.parentProps.parentState;

    // formData.append('name', this.state.file.name );
    let CBSurl = `${remoteip}/file/${pageData[filename]}`;
    // console.log({CBSurl}) 

    window.open(CBSurl, '_blank');

  }

  render() {
    let current = this;
    let { name, Blocktype, Bcolor, fileTypes, label, isReadOnly } = this.props.component;

    const { preview, fileuploadMessage, size } = this.state;
    let { modalname, pageData, formState } = this.props.parentState;
    let { unique_id } = pageData;
    if (isReadOnly == 'edit' && unique_id) {
      isReadOnly = true;
    }
    let boxvalue;
    let classval = "";
    let classval1 = "";


    Blocktype === "block" && (classval = "btn-block")
    Bcolor ? (classval1 = Bcolor) : (classval1 = "info");
    // let modalname=openmodals[openmodals.length-1];
    if (modalname && pageData[modalname]) {
      boxvalue = pageData[modalname][name]
        ? pageData[modalname][name]
        : "";
    } else {
      boxvalue = pageData[name]
        ? pageData[name]
        : "";
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();

    isReadOnly = isReadOnly == 'edit' ? false : isReadOnly;

    return (
      <div
        className={`form-group form-check  ${this.props.component.widths.parent
          }`}
      >
        {" " + this.props.parentState.errorMessages != undefined &&
          this.props.parentState.errorMessages[name] ? (
          <span>
            <UncontrolledTooltip placement="right" target={tooltipID2}>
              can not be empty{" "}
            </UncontrolledTooltip>
          </span>
        ) : (
          ""
        )}

        {!isReadOnly &&

          <div className="upload-btn-wrapper row" >
            <Button className="btn" style={{ cursor: "pointer" }} outline color={classval1} size="sm">{label}</Button>
            <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" name={name} onChange={e => !isReadOnly ? this.onUploadFile(e, fileTypes) : false} onClick={(event) => {
              event.target.value = null
            }}
            />
            {fileuploadMessage ? <span>{fileuploadMessage}</span> : ""}
            {preview && <span>&nbsp;<span onClick={() => !isReadOnly ? this.onDownloadFile(name) : false} className=""> {preview} </span>({`${size}`})</span>}
          </div>

        }

      </div>
    );
  }
}

export default FileUploadCustom;
